{
  "site": "https://lens-specs.com",
  "pages": {
    "/": {
      "title": "Camera lens specifications, cited — lens-specs",
      "description": "Camera lens specifications you can filter and compare, with a source for every figure."
    },
    "/compare": {
      "title": "Compare lenses — lens-specs",
      "description": "Chosen lenses side by side, every specification with its source."
    },
    "/about": {
      "title": "About — lens-specs",
      "description": "A database of camera lens specifications where every figure says where it came from."
    },
    "/methodology": {
      "title": "Methodology — lens-specs",
      "description": "The rules that decide which value a cell shows, and how to read it."
    },
    "notfound": {
      "title": "Page not found — lens-specs",
      "description": "There's nothing at this address. It may be mistyped, or it may have moved."
    }
  }
}
